module.exports = __webpack_public_path__ + "img/deluxe-vehicle-filter-mitsu.81664c9a.png";